var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#D3D905"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45455 6C5.65455 6 5 6.66316 5 7.47368V16.3158C5 17.1263 5.65455 17.7895 6.45455 17.7895H14.0909C13.8931 17.321 13.7703 16.8235 13.7273 16.3158H6.45455V8.94737L12.2727 12.6316L18.0909 8.94737V11.1579C18.2121 11.1535 18.3334 11.1535 18.4545 11.1579C18.822 11.159 19.1881 11.2035 19.5455 11.2905V7.47368C19.5455 6.66316 18.8909 6 18.0909 6H6.45455ZM6.45455 7.47368H18.0909L12.2727 11.1579L6.45455 7.47368ZM18.0909 11.8947L16.4545 13.5526L18.0909 15.2105V14.1053C18.5731 14.1053 19.0356 14.2993 19.3766 14.6448C19.7175 14.9903 19.9091 15.4588 19.9091 15.9474C19.9091 16.2421 19.8436 16.5221 19.72 16.7726L20.5127 17.5758C20.8182 17.1116 21 16.5516 21 15.9474C21 14.3189 19.6982 13 18.0909 13V11.8947ZM15.6691 14.3189C15.3636 14.7832 15.1818 15.3432 15.1818 15.9474C15.1818 17.5758 16.4836 18.8947 18.0909 18.8947V20L19.7273 18.3421L18.0909 16.6842V17.7895C17.6087 17.7895 17.1462 17.5954 16.8053 17.2499C16.4643 16.9045 16.2727 16.4359 16.2727 15.9474C16.2727 15.6526 16.3382 15.3726 16.4618 15.1221L15.6691 14.3189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8779 15.2412C15.8083 15.4666 15.7725 15.704 15.7725 15.9473C15.7725 16.5663 16.0152 17.1618 16.4492 17.6016C16.8834 18.0414 17.474 18.289 18.0908 18.2891H18.5908V17.9023L19.0244 18.3418L18.5908 18.7812V18.3945H18.0908C16.7659 18.3945 15.6816 17.3057 15.6816 15.9473C15.6817 15.6752 15.7267 15.4144 15.8076 15.1709L15.8779 15.2412ZM19.0459 7.47363V10.6934C18.8949 10.6755 18.743 10.6665 18.5908 10.6621V8.03906L17.8232 8.52539L12.2725 12.0391L6.72168 8.52539L5.9541 8.03906V16.8154H13.2891C13.3166 16.9749 13.3508 17.1329 13.3926 17.2891H6.4541C5.93658 17.2888 5.5 16.8558 5.5 16.3154V7.46094L6.1875 7.89648L12.0049 11.5801L12.2725 11.75L12.54 11.5801L18.3584 7.89648L19.0449 7.46094C19.045 7.46516 19.0459 7.46939 19.0459 7.47363ZM17.5908 13.5H18.0908C19.4158 13.5 20.4999 14.5889 20.5 15.9473C20.5 16.2191 20.4538 16.4794 20.373 16.7227L20.3027 16.6514C20.372 16.4264 20.4092 16.19 20.4092 15.9473C20.4092 15.3283 20.1663 14.7336 19.7324 14.2939C19.2982 13.854 18.7078 13.6055 18.0908 13.6055H17.5908V13.9912L17.1572 13.5527L17.5908 13.1133V13.5ZM6.4541 6.5H18.0908C18.4328 6.5 18.7384 6.68959 18.9072 6.97363H5.6377C5.7905 6.71637 6.05564 6.53653 6.3584 6.50488L6.4541 6.5Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_11",
    x: 1,
    y: 6,
    width: 24,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_11",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendMail);
export default __webpack_public_path__ + "static/media/ResendMail.8aa41ee5d18d836b31f7a5100b7ce9eb.svg";
export { ForwardRef as ReactComponent };